// extracted by mini-css-extract-plugin
module.exports = {"root":"az_SJc","stickyHeader":"az_TJc"};